// this whole file seems senseless
// it's just to have an unififed way to create commands, and messages over all bot communication aspects

import type { ChatInputType, Intent } from "@/types";
import type { WSBotMessage } from "@/types/WSBotMessage";

export type Commands = IsTypingCommand | QuickRepliesCommand | SetInputTypeCommand;

type Command = {
  type: string;
  key: string;
  timestamp: number;
  cmd: string;
  uuid?: string;
}

export type IsTypingCommand = Command & {
  value: boolean;
}

export type QuickRepliesCommand = Command & {
  value: Intent[];
}

export type SetInputTypeCommand = Command & {
  value: ChatInputType;
}

export const CommandBuilder = {
  isTyping(message: WSBotMessage, uuid?: string): IsTypingCommand {
    return {
      type: 'cmd',
      key: `cmd-typing-${message.time}`,
      timestamp: message.time,
      cmd: 'typing',
      value: message.typing || false,
      uuid,
    }
  },
  quickReplies(message: WSBotMessage, uuid?: string): QuickRepliesCommand {
    const value = message.quick_replies?.map((qr) => {
      return {
        text: qr.label,
        intent: qr.intent,
      }
    }) || [] as Intent[];
    // @ts-expect-error - replaceAll is fine
    const key = value?.map((qr) => qr?.text?.replaceAll(' ', '')).join('')
    if (value?.length === 0) throw new Error('Quick replies must have at least one item')
    return {
      type: 'cmd',
      key: `cmd-qr-${message.time}-${key}`,
      timestamp: message.time,
      cmd: 'qr',
      value,
      uuid,
    }
  },
  setInputType(message: WSBotMessage, uuid?: string): SetInputTypeCommand {
    const value = message.inputType;
    return {
      type: 'cmd',
      key: `cmd-setInputType-${message.time}`,
      timestamp: message.time,
      cmd: 'setInputType',
      value: value || { type: 'text' },
      uuid,
    }
  },
};

export function createInputTypeCommand(inputType: ChatInputType, time: number): SetInputTypeCommand {
  return {
    type: 'cmd',
    key: `cmd-setInputType-${time}`,
    timestamp: time,
    cmd: 'setInputType',
    value: inputType,
  }
}

export function createIsTypingCommand(value: boolean): IsTypingCommand {
  const time = Date.now()
  return {
    type: 'cmd',
    key: `cmd-typing-${time}`,
    timestamp: time,
    cmd: 'typing',
    value,
  }
}
